import { defineChannelContract } from 'shared/channels';
import type { FilterValues } from 'shared/types/analytics';
import type { ChartFiltersId } from './chartFiltersModel';

/**
 * Contract of the page and the service worker for saved chart filters, which
 * the worker keeps across project switches.
 */
export const chartFiltersContract = defineChannelContract<{
  requests: {
    /** `undefined` when the chart has no saved filters. */
    getSaved: { request: { chartId: ChartFiltersId }; response: FilterValues | undefined };
    save: { request: { chartId: ChartFiltersId; filters: FilterValues }; response: void };
  };
  events: Record<never, never>;
}>('chartFilters');
